import { computed, ref } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'
import OfferPopup from '../OfferPopup/OfferPopup'

export default ({
  props: {
    item: Object,
    myOffer: Object,
  },
  components: {
    OfferPopup,
  },
  setup(props, context) {
    const { $store } = context.root
    const { emit } = context
    const offerWasRefused = computed(() => props.item.tenderOffers.length && props.item.tenderOffers[0].state === 'refuse')
    const isCash = computed(() => props.item.payment === 'cash')
    const showTransportForm = ref(false)
    const price = computed(() => ((props.myOffer?.price % 1) ? parseFloat(props.myOffer?.price).toFixed(1) : Math.round(props.myOffer?.price)))

    const { makeRequest, loading } = useRequest({
      context,
      successMessage: 'Тендер обновлен!',
      request: data => $store.dispatch('materialDeliveries/updateOffer', data),
    })

    const update = () => {
      showTransportForm.value = false
      emit('update')
    }

    const refusePrice = async () => {
      await makeRequest({ id: props.item.id, data: { state: 'cancelled' } })
      emit('update')
    }

    return {
      offerWasRefused,
      isCash,
      loading,
      price,
      showTransportForm,
      refusePrice,
      update,
    }
  },
})
